import type { ComponentType } from "react";

// Every container Application loads lazily (PLAY-5251 design D1). Each `import()` here becomes
// its own chunk in the Vite build, so no module in the main bundle may import one of these
// containers statically - Rollup would fold it back into the main chunk (design D8).
//
// These are loaders, not `lazy()` components: React caches a rejected `lazy()` promise for
// good, so `LazyContainer` builds its own `lazy()` from a loader and builds a fresh one to retry
// after a failed chunk load (design D6).
//
// `Error` and `Update` are deliberately absent: they stay static imports in Application because
// they show exactly when a chunk download is most likely to fail (design D7).
export type ContainerLoader = () => Promise<{ default: ComponentType<any> }>;

export const lazyContainers = {
  Menu: () => import("containers/Menu"),
  Navigation: () => import("containers/Navigation"),
  GameNavigation: () => import("containers/GameNavigation"),
  Content: () => import("containers/Content"),
  Categories: () => import("containers/Categories"),
  Exit: () => import("containers/Exit"),
  Search: () => import("containers/Search"),
  GameActionCollapse: () => import("containers/GameActionCollapse"),
  ShowMore: () => import("containers/ShowMore"),
  ShowMoreDesktop: () => import("containers/ShowMoreDesktop"),
  Games: () => import("containers/Games"),
  TournamentViewDetailsDesktop: () => import("containers/TournamentViewDetailsDesktop"),
  FreeRounds: () => import("containers/FreeRounds"),
  TournamentLeaderboard: () => import("containers/TournamentLeaderboard"),
  JackpotDetails: () => import("containers/JackpotDetails"),
  JackpotViewDetails: () => import("containers/JackpotViewDetails"),
  GameAction: () => import("containers/GameAction"),
  History: () => import("containers/History"),
  RoundHistoryPerGame: () => import("containers/RoundHistoryPerGame"),
  GameRoundResult: () => import("containers/GameRoundResult"),
  BetHistory: () => import("containers/BetHistory"),
} satisfies Record<string, ContainerLoader>;

export type LazyContainerName = keyof typeof lazyContainers;
